import React from "react"
import { useI18next } from "gatsby-plugin-react-i18next"

import Dropwdown from "../UI/Dropdown/dropdown"

const getLanguagesOptions = () => {
  return [
    { id: 1, value: "en", name: "English" },
    { id: 2, value: "es", name: "Español" },
  ]
}

const languageNames = {
  en: "English",
  es: "Español",
}

const LanguageSwitcher = props => {
  const { changeLanguage, language } = useI18next()

  const languageChangeHandler = lang => {
    changeLanguage(lang)
  }

  const options = getLanguagesOptions()

  return (
    <Dropwdown
      options={options}
      value={languageNames[language]}
      onChange={languageChangeHandler}
    />
  )
}

export default LanguageSwitcher
